<template>
  <div>
    <v-card>
      <Subheader title="Guideline Standards">
        <!-- <v-btn color="add" @click="addStandard()">
            <v-icon class="mr-1">add</v-icon>{{ $t('Button.AddAnalyteLink') }}
          </v-btn> -->
      </Subheader>
      <v-data-table :headers="headers" :items="currentStandards" hide-actions>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.AnalyteNameInGuideline }}</td>
          <td class="text-xs-left" v-html="getGuidelineValue(props.item)"></td>
          <td class="text-xs-left">{{ props.item.Unit }}</td>
          <td width="50%">
            <v-chip label class="emphasize-close" :class="differentUnit(link, props.item)?'amber lighten-4':''" @input="deleteStandard(link)" v-for="(link, index) in props.item.linkedAnalytes" :key="`link-${index}`" close>
              <v-tooltip bottom v-if="differentUnit(link, props.item)">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">help_outline</v-icon>
                </template>
                <span>{{ $t('TenantGuidelinesDetailStandards.tooltipMsg') }}</span>
              </v-tooltip>
              <div class="mr-2">
                <router-link :to="{ name: 'AnalyteDetailManage', params: { analyteId: link.analyteId.toString() } }">{{ link.analyteName }}</router-link>
              </div>
            </v-chip>
            <div style="display: flex; width: 100%;" class="align-center" v-if="props.item.linkedAnalyte">
              {{ props.item.linkedAnalyte.analyteName }}
            </div>
            <v-btn depressed small class="min-width-none" @click="addStandard(props.item)">
              <v-icon color="success">add</v-icon>
              <span class="text-none">Analyte</span>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <AppModal v-model="addDialog" persistent max-width="800px">
      <template v-slot:title>
        {{ $t('GuidelinesDetailStandards.addTitle') }}
      </template>
      <template v-slot:text>
        <v-form v-model="valid" lazy-validation ref="form" style="width: 100%">
          <v-autocomplete disabled required label="Standard" v-model="AnalyteStandardMap.Standard" v-bind:hint="'Standard is used in unit group(s):' + getHint(AnalyteStandardMap.Standard)" persistent-hint :items="originalData.Standards" :rules="[rules.required]" item-text="AnalyteNameInGuideline" return-object></v-autocomplete>
          <v-autocomplete required label="Linked Analyte" v-model="AnalyteStandardMap.Analyte" :items="availableAnalyteList" item-text="AnalyteName" return-object :rules="[rules.required]"></v-autocomplete>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" color="success" @click="checkData()">
          <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn @click="close()">{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </AppModal>

    <v-dialog v-model="confirmDialog" max-width="500">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>{{ $t('GuidelinesDetailStandards.deleteTitle') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="confirmDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          {{ $t('GuidelinesDetailStandards.confirmTitleMsg', { analyteName: deleteAnalyteStandardMap.analyteName}) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="delete" dark @click.native="deleteGuidelineStandard()">
            <v-icon class="mr-1">link_off</v-icon>{{ $t('Button.UnlinkAnalyte') }}
          </v-btn>
          <v-btn @click.native="confirmDialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import AnalyteUtil from '../mixins/AnalyteUtil'
  import AppModal from '@/components/generic/AppModal'
  import Subheader from '@/components/generic/Subheader'
  import { checkUnitNamesEqual } from '@/store/unit'
  import {
    sortObject,
  } from '@/helpers/sorting'
  import {
    isSubset,
  } from '@/helpers/arrays'
  import { AddGuidelineActionName, AmmoniaLookupTable, LookupTable } from '@/components/mixins/GuidelinesManageUtil'
  const guidelines = createNamespacedHelpers('guidelines')
  const analyte = createNamespacedHelpers('analyte')
  const authenticate = createNamespacedHelpers('authenticate')
  const unit = createNamespacedHelpers('unit')
  export default {
    components: {
      AppModal,
      Subheader,
    },
    mixins: [AnalyteUtil],
    props: {
      name: {
        type: String,
        default: '',
      },
      currentGuideline: {
        type: Object,
        default: () => {},
      },
      isAddpageForm: {
        type: Boolean,
        default: true,
      },
      isTenantEditable: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      this.setGuidelineData()
      this.getAnalyteStandardMaps()
    },
    data() {
      return {
        addDialog: false,
        confirmDialog: false,
        titleInfo: '',
        valid: false,
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        AnalyteStandardMap: {},
        AnalyteStandardMaps: [],
        availableAnalyteList: [],
        targetGroups: [],
        originalData: {},
        deleteAnalyteStandardMap: '',
        headers: [{
          text: 'Standard',
          align: 'left',
          value: 'AnalyteNameInGuideline',
        },
        {
          text: 'Guideline',
          align: 'left',
          value: 'StandardValue',
        },
        {
          text: 'Unit',
          align: 'left',
          value: 'Unit',
        },
        {
          text: 'Linked Analyte',
          align: 'left',
          value: 'usedInAnalyte',
        },
        ],
        pagination: {
          sortBy: 'AnalyteNameInGuideline',
          rowsPerPage: 10,
        },
      }
    },
    computed: {
      ...guidelines.mapGetters(['Guidelines', 'analyteInGuidelineList']),
      ...analyte.mapGetters(['tenantAnalyteList']),
      ...authenticate.mapGetters(['currentUserGroup']),
      ...unit.mapGetters(['allUnits', 'allUnitGroups']),
      rules() {
        return {
          required: (v) => !!v && !!v.Id || 'Required.',
        }
      },
      standardMapsIndex() {
        let index = {}
        this.AnalyteStandardMaps.forEach(asm => {
          if (!index[asm.StandardId]) index[asm.StandardId] = []
          index[asm.StandardId].push(asm)
        })
        return index
      },
      analytesIndex() {
        let index = {}
        this.tenantAnalyteList.forEach(a => index[a.Id] = a)
        return index
      },
      currentStandards() {
        if (!this.originalData || !this.originalData.Standards) return []
        return this.originalData.Standards.map(s => {
          let linkedAnalytes = this.makeLinkedAnalytes(s.Id)

          return {
            ...s,
            linkedAnalytes,
          }
        })
      },
    },
    watch: {
      currentGuideline() {
        this.setGuidelineData()
      },
    },
    methods: {
      ...guidelines.mapActions(['GetGuidelineAnalyteStandardMaps']),
      ...analyte.mapActions(['deleteAnalyteGuideline', 'addAnalyteGuideline']),
      makeLinkedAnalytes(standardId) {
        let standardMaps = this.standardMapsIndex[standardId]
        if (!standardMaps) return []

        let analytes = standardMaps.map(sm => this.analytesIndex[sm.AnalyteId]).filter(a => a)
        if (!analytes) return []

        return analytes.map(analyte => ({
          standardId,
          analyteId: analyte.Id,
          analyteName: analyte.AnalyteName,
        }))
      },
      startSnack(snackColor, snackMessage) {
        this.snackMessage = snackMessage
        this.snackColor = snackColor
        this.snackbar = true
      },
      setGuidelineData() {
        if (this.name != AddGuidelineActionName && !this.isAddpageForm) {
          this.originalData = JSON.parse(JSON.stringify(this.currentGuideline))

          this.originalData.Standards = this.originalData.Standards.sort(sortObject('AnalyteNameInGuideline'))
        }
      },
      getAnalyteStandardMaps() {
        let options = {
          data: {
            guidelineId: this.currentGuideline.Id,
            tenantId: this.currentUserGroup.id,
          },
          successCb: (data) => {
            this.AnalyteStandardMaps = data
          },
        }
        this.GetGuidelineAnalyteStandardMaps(options)
      },
      getGuidelineValue(guideline) {
        if(guideline.ValueType == AmmoniaLookupTable) {
          return JSON.parse(guideline.StandardValue).Description
        }
        if(guideline.ValueType == LookupTable) {
          return '<b class="warning">Viewing lookup table guideline value is not supported yet.</b>'
        }
        return guideline.StandardValue.replace('-99999', 'None')
      },
      addStandard(standard = {}) {
        this.AnalyteStandardMap = {
          Standard: standard,
          Analyte: {},
        }
        let groups = this.getHint(this.AnalyteStandardMap.Standard)
        let matchUnits = this.allUnits.filter(x => x.Groups.some(y => groups.includes(y.Name))).map(x => x.Name)
        let list = JSON.parse(JSON.stringify(this.tenantAnalyteList))
        list = list.filter(x => !!x.DefaultUnitId && matchUnits.includes(this.allUnits.find(y => y.Id == x.DefaultUnitId).Name))
        let IdArr = this.AnalyteStandardMaps.map(x => x.AnalyteId)
        this.availableAnalyteList = list.filter(x => !IdArr.includes(x.Id))

        this.titleInfo = 'Add a new Guideline Standards'
        this.addDialog = true
      },
      deleteStandard(data) {
        this.deleteAnalyteStandardMap = data
        this.confirmDialog = true
      },
      close() {
        this.addDialog = false
      },
      checkData() {
        if (this.$refs.form.validate()) {
          let matched = this.AnalyteStandardMaps.find(x => x.AnalyteId == this.AnalyteStandardMap.Analyte.Id &&
            x.StandardId == this.AnalyteStandardMap.Standard.Id)
          if (!matched) {
            this.saveGuidelineStandard()
          } else {
            this.startSnack('info', 'This analyte is already linked.')
          }
        } else {
          this.startSnack('error', this.$t('GuidelinesDetailStandards.saveFailMsg'))
        }
      },
      saveGuidelineStandard() {
        let matched = this.analyteInGuidelineList.find(x => x == this.AnalyteStandardMap.AnalyteNameInGuideline)
        if (matched) {
          this.AnalyteStandardMap.WaterQualityLabAnalyteId = matched.WaterQualityLabAnalyteId
          this.AnalyteStandardMap.AnalyteNameInGuideline = matched.AnalyteNameInGuideline
        }
        let options = {
          data: {
            Id: null,
            AnalyteId: this.AnalyteStandardMap.Analyte.Id,
            GuidelineId: this.AnalyteStandardMap.Standard.GuidelineId,
            StandardId: this.AnalyteStandardMap.Standard.Id,
          },
          successCb: () => {
            this.getAnalyteStandardMaps()
            this.startSnack('success', this.$t('AnalyteGuidelinesManagement.successSaveMsg'))
            this.close()
          },
          failedCb: (err) => {
            this.startSnack('error', err.response.data.Message)
          },
        }
        this.addAnalyteGuideline(options)
      },
      deleteGuidelineStandard() {
        let options = {
          data: {
            AnalyteId: this.deleteAnalyteStandardMap.analyteId,
            StandardId: this.deleteAnalyteStandardMap.standardId,
          },
          successCb: () => {
            this.getAnalyteStandardMaps()
            this.confirmDialog = false
            this.startSnack('success', this.$t('AnalyteGuidelinesManagement.successDeleteMsg'))
          },
          failedCb: () => {
            this.startSnack('error', this.$t('AnalyteGuidelinesManagement.errorMsg'))
          },
        }
        this.deleteAnalyteGuideline(options)
      },
      getHint(standard) {
        if (standard && standard.Unit) {
          var matchedUnit = this.allUnits.find(x => checkUnitNamesEqual(x.Name, standard.Unit))
          return (matchedUnit && matchedUnit.Groups) ? matchedUnit.Groups.map(x => x.Name) : ''
        }
        return ''
      },
      differentUnit(analyte, standard) {
        let analyteUnitId = this.tenantAnalyteList.find(x => x.Id == analyte.analyteId).DefaultUnitId
        let analyteUnitGroup = this.allUnits.find(x => x.Id == analyteUnitId).Groups.map(y => y.Id)
        let standardUnitGroup = this.allUnits.find(x => checkUnitNamesEqual(x.Name, standard.Unit)).Groups.map(y => y.Id)
        return !isSubset(analyteUnitGroup, standardUnitGroup)
      },
    },
  }
</script>

<style lang="css">

</style>